import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const LanguageSwitcher = ({ toggleLanguage, currentLang }) => {
const flags = {
  en: `${process.env.PUBLIC_URL}/images/us.svg`,   // USA flag image path
  es: `${process.env.PUBLIC_URL}/images/spain.svg` // Spain flag image path
};


  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: { xs: 30, sm: 12, md: 16 },
        backgroundColor: 'white',
        padding: '8px 12px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        zIndex: 9999,
        maxWidth: 'calc(100vw - 32px)', // prevent overflow on small screens
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      <Link
        component="button"
        onClick={toggleLanguage}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          textDecoration: 'none',
        }}
      >
        <img
          src={currentLang === 'en' ? flags.es : flags.en}
          alt={currentLang === 'en' ? 'Spanish Flag' : 'USA Flag'}
          style={{ width: 24, height: 24, objectFit: 'contain' }}
        />
        <Typography
          variant="body2"
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        >
          {currentLang === 'en' ? 'ES' : 'EN'}
        </Typography>
      </Link>
    </Box>
  );
};

export default LanguageSwitcher;
